module.exports = __webpack_public_path__ + "media/bootstrap-icons/node-plus-fill-0b0ebffe.svg";